import App from './root.component';

export default App;
